import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import {
  CURRENCY,
  LIBERIS_MAX_LOAN_AMOUNT,
  PRAGMA_MAX_LOAN_AMOUNT,
  MIN_LOAN_AMOUNT,
} from '@repo/shared/constants';
import { providerType } from '@repo/shared/types';
import { areAllProviderNotPromoted } from '@repo/store/helpers';
import { useProviderStore } from '@repo/store/provider';
import { AmountSelector } from '@repo/ui';

import { useMainHubStoreState } from '@/store/main-hub.store';

import { getMinMaxLoanAmount } from '../common/helpers/get-min-max-loan-amount';

export function LiberisAmountForm() {
  const { t } = useTranslation();
  const { merchantResponseData } = useMainHubStoreState();
  const {
    state: { isAvailableMultiprovider },
  } = useProviderStore();

  let loanAmountDefaultValues = getMinMaxLoanAmount(
    merchantResponseData,
    providerType.enum.liberis,
  );

  if (
    merchantResponseData &&
    areAllProviderNotPromoted(merchantResponseData) &&
    isAvailableMultiprovider
  ) {
    const pragmaMinMaxLoanAmount = getMinMaxLoanAmount(
      merchantResponseData,
      providerType.enum.pragma,
    );

    loanAmountDefaultValues = {
      min: Math.min(loanAmountDefaultValues.min, pragmaMinMaxLoanAmount.min),
      max:
        Math.max(loanAmountDefaultValues.max, pragmaMinMaxLoanAmount.max) ||
        Math.max(LIBERIS_MAX_LOAN_AMOUNT, PRAGMA_MAX_LOAN_AMOUNT),
    };
  }

  return (
    <Box paddingX={2}>
      <Typography fontSize={20} marginBottom={2}>
        {t('welcomePage.loanApplicationPossible.liberis.amountForm.howMuchDoYouWantToBorrow')}
      </Typography>
      <AmountSelector
        name="amount"
        max={loanAmountDefaultValues.max}
        min={MIN_LOAN_AMOUNT}
        currency={CURRENCY}
      />
    </Box>
  );
}
